import Vue from 'vue'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    ShipmentRuleBlockingCauseCreateRequest,
    ShipmentRuleBlockingCauseResponse
} from '@/modules/configurationModule/detail/shipments/shipment-rules/services/shipment-rule-blocking-cause/shipment-rule-blocking-cause.dto'

export default class ShipmentRuleBlockingCauseService extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<ShipmentRuleBlockingCauseResponse>> {
        const response = await this.axios.put<IResponseAgGrid<ShipmentRuleBlockingCauseResponse>>(`/configuration/shipmentRuleBlockingCauses/`, filterModel, { params })
        return response.data
    }
    async createShipmentRuleBlockingCause(request: ShipmentRuleBlockingCauseCreateRequest): Promise<ShipmentRuleBlockingCauseResponse> {
        const response = await this.axios.post<ShipmentRuleBlockingCauseResponse>(`/configuration/shipmentRuleBlockingCauses/`, request)
        return response.data
    }
    async deleteShipmentRuleBlockingCauseById(shipmentRuleBlockingCauseId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/shipmentRuleBlockingCauses/${shipmentRuleBlockingCauseId}`)
        return response.data
    }
}

export const shipmentRuleBlockingCauseService = new ShipmentRuleBlockingCauseService()
